import script from "./EditableSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableSelect.vue?vue&type=script&lang=ts&setup=true"

import "./EditableSelect.vue?vue&type=style&index=0&id=beac7710&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beac7710"]])

export default __exports__